import StatisticsCard from "./StatisticsCard";

export default function InvitationActivity({ data }) {
    return (<div className="row">
        <div className="col-xl-12 mb-4 col-lg-12 col-12">
            <h5 className="card-title fs-15 mb-1">
                Activity
            </h5>
            <div className="row-cols-2 row-cols-xl-4 mt-2 row">
                <StatisticsCard title={"Invitation Visit"} value={data ? data.invitationVisits : 0} imgUrl=""
                    className="col mb-20px" />
                <StatisticsCard title={"Demo Visit"} value={data ? data.demoVisits ?? 0 : 0} imgUrl=""
                    className="col mb-20px" />
                <StatisticsCard title={"Website Visit"} value={data ? data.siteVisits : 0} imgUrl=""
                    className="col mb-20px" />
                <StatisticsCard title={"Registrations"} value={0} imgUrl=""
                    className="col mb-20px" />
            </div>
        </div>
    </div>
    )
}